export const getDataFromUploadedFile = async (files) => {
  const filePromises = files.map((file) => {
    return new Promise((resolve, reject) => {
      try {
        const reader = new FileReader();
        reader.onload = async () => {
          resolve({"fileName": file.name, "fileContent": reader.result?.replace(/^data:(.*,)?/, '')})
        };
        reader.onerror = (error) => {
          reject(error);
        };
        reader.readAsDataURL(file);
      } catch (e) {
        reject(error);
      }
    });
  });
  // Wait for all promises to be resolved
  const fileInfos = await Promise.all(filePromises);

  console.log("COMPLETED file processing");

  return fileInfos;
};
